import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 26"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M1.2 20.09H6c.36 0 .6-.117.84-.354l13.2-13a1.13 1.13 0 0 0 0-1.654L15.24.355a1.17 1.17 0 0 0-1.68 0l-13.2 13c-.24.236-.36.472-.36.827v4.727c0 .71.48 1.182 1.2 1.182m1.2-5.435 12-11.819 3.12 3.073-12 11.818H2.4zm20.4 8.981H1.2c-.72 0-1.2.473-1.2 1.182C0 25.528.48 26 1.2 26h21.6c.72 0 1.2-.473 1.2-1.182s-.48-1.182-1.2-1.182"
    }, null, -1)
  ]))]))
}
export default { render: render }